import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppShell, bindShellUser } from '@/app/shell';

/**
 * Tenant pages inside the application shell (sidebar, workspace tabs, page header). The dashboard viewer
 * (`/t/$tenantSlug`) and the section viewer are full-bleed and live outside this layout.
 */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell')({
  beforeLoad: ({ context }) => bindShellUser(context.me.user.id),
  component: TenantShell,
});

function TenantShell() {
  const { tenant } = Route.useRouteContext();
  return (
    <AppShell tenant={tenant}>
      <Outlet />
    </AppShell>
  );
}
